import { render, staticRenderFns } from "./RewardEdit.vue?vue&type=template&id=48b92b90&scoped=true&"
import script from "./RewardEdit.vue?vue&type=script&lang=js&"
export * from "./RewardEdit.vue?vue&type=script&lang=js&"
import style0 from "./RewardEdit.vue?vue&type=style&index=0&id=48b92b90&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b92b90",
  null
  
)

export default component.exports